/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { IndexDependencies } from './dependenciesIndexClass.generated.js';
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { subsetDependencies } from './dependenciesSubset.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSetIntersect } from '../../factoriesAny.js';
export var setIntersectDependencies = {
  DenseMatrixDependencies,
  IndexDependencies,
  compareNaturalDependencies,
  sizeDependencies,
  subsetDependencies,
  typedDependencies,
  createSetIntersect
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSetIntersect.generated.js
// module id = IbLX
// module chunks = 3